import type { AnchorHTMLAttributes } from 'react';

export const emailLink = <T extends AnchorHTMLAttributes<HTMLAnchorElement>>(
  text: string,
  Component: React.ComponentType<T>
) => <Component {...({ href: `mailto:${text}` } as T)}>{text}</Component>;
